import {config} from './hapi.config';

// https://nuxt.com/docs/api/configuration/nuxt-config
export default defineAppConfig({
	host: config[config.default].host,
	lang: config[config.default].lang,
	meta: [
		{property: 'og:locale:alternate', content: 'si_SI'},
		{property: 'og:locale:alternate', content: 'bs_BA'},
	],
	catalog: {
		fetch: {
			check_lists: 'webcatalog_cs-fm-hr,webcatalog_cs-lb-hr,webcatalog_cs-lt-hr,webcatalog_3d-ar-hr',
		},
	},
});